import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import add from '../../../img/add.svg';
import details from '../../../img/details.svg';
import sortasc from '../../../img/sort-asc.svg';
import sortdesc from '../../../img/sort-desc.svg';
import del from '../../../img/del.svg';



export default class TrainingParticipantScreen extends React.Component {

    constructor(props) {
        super(props);

        var trainingid = null
        var sortField = null
        var sortOrder = null
        var pageCount = 0
        var training = null
        
        const args = props.args === undefined ? {} : props.args

        if (args.training !== undefined) {
            training = args.training
        }

        if (args.trainingid !== undefined) {
            trainingid = args.trainingid
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {args: args,
                      pageLimit: 25, 
                      pageCount: pageCount,   
                      nameCriteria: "",
                      prevNameCriteria:"",
                      trainingid: trainingid,
                      training: training,
                      sortField: sortField, 
                      sortOrder: sortOrder,
                      participants: []};

              

        this.nameSearch = this.nameSearch.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)

        setTimeout(this.nameSearch, 2000);
    }

    async componentDidMount() {
        this.getDataWithCritera()
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }


    getDataWithCritera() {

        var parameters = {}

        if (this.state.trainingid) {
            parameters.trainingid = this.state.trainingid
        } 

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get('/training/participant', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({participants: res.data})
        })    
        .catch(error=>console.log(error))
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCritera)
        }
    }

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break  
            case "location" :
                if (currentField === "location") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "location"
                    currentOrder = "asc"
                }
            break           
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCritera)
    }

    openVolunteer(id) {
        this.props.navigate("volunteer", {caller: "training-participant", callargs: this.state.args, volunteer: id})
    }

    selectParticipant() {
        this.props.navigate("training-participant-select", {caller: "training-participant", callargs: this.state.args, trainingid: this.state.trainingid, training: this.state.training}) 
    } 

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    deleteParticipant(id) {
        BaseApi.delete('/training/participant', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: id}, withCredentials: true})
        .then(res => {
            this.getDataWithCritera()
        })    
        .catch(error=>console.log(error))
    }
    
    renderParticipant(participant) {
    
        return (
            <div class="row" style={{"height" : "50px"}}>
                    <div class="col-4 text-left border border-white" style={{"background-color" : "#eee"}}>{participant.name}</div>
                    <div class="col-3 text-left border border-white" style={{"background-color" : "#eee"}}>{participant.location}</div>
                    <div class="col-2 text-left border border-white" style={{"background-color" : "#eee"}}>{participant.phone}</div>
                    <div class="col-1 border border-white"  style={{"background-color" : "#eee"}}>{participant.occupation}</div>
                    <div class="col-1 border border-white"  style={{"background-color" : "#eee"}} onClick={()=>this.openVolunteer(participant.volunteerid)}><img src={details} height="16" width="16"/></div>
                    <div class="col-1 border border-white"  style={{"background-color" : "#eee"}} onClick={()=>this.deleteParticipant(participant.id)}><img src={del} height="16" width="16"/></div>
            </div>
        )        
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Участники"}/>
                <div class="mt-5 col-md-4">
                    <form title="Фильтр">
                        <div class="form-group">
                            <label for="name"> Имя:</label>
                            <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                        </div>
                    </form>
                </div>
                <div class="row" style={{"height" : "50px"}}>
                    <div class= "col-md-4 offset-md-8 float-left">
                        <button class="btn btn-primary" onClick={()=>{this.prevPage()}}>Предыдущие</button> 
                        <button class="btn btn-primary" style={{"margin-left" : "10px"}} onClick={()=>{this.nextPage()}}>Следующие</button> 
                    </div>
                </div>
                <div class="row" style={{"height" : "50px"}}>
                    <div class="col-4 text-left border border-white"
                         id="nameCaption"    
                         style={{"background-color" : "#0ee"}}
                         onClick={this.sortClicked}>
                            ФИО
                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-3 text-left border border-white"
                         id="locationCaption"    
                         style={{"background-color" : "#0ee"}}
                         onClick={this.sortClicked}>
                            Локация
                            {this.isFieldSortedDesc("location") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("location") && <img src={sortasc} height="16" width="16"/>}
                    </div>

                    <div class="col-2 text-left border border-white"
                         id="phoneCaption"    
                         style={{"background-color" : "#0ee"}}
                         onClick={this.sortClicked}>
                            Телефон
                    </div>
                    <div class="col-1 border border-white"
                         id="detailCaptuon" 
                         style={{"background-color" : "#0ee"}}>
                            Занят
                    </div>  
                    <div class="col-1 border border-white"
                         id="detailCaptuon" 
                         style={{"background-color" : "#0ee"}}
                         onClick={()=>{this.selectParticipant()}}>
                         <img src={add} height="16" width="16"/>
                    </div>    
                    <div class="col-1 border border-white"
                         id="detailCaptuon" 
                         style={{"background-color" : "#0ee"}}>
                    </div>      
                </div>    
                {this.state.participants.map((value, index) => this.renderParticipant(value))}
            
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/training/training-participants.js